const HUB_PAGES = {
  HOME: {
    href: '/home',
    eventName: 'home',
  },
  SOUNDS: {
    href: '/sounds',
    eventName: 'sounds',
  },
  SONIDOS: {
    href: '/sonidos',
    eventName: 'sonidos',
  },
  THEATER: {
    href: '/theater',
    eventName: 'theater',
  },
  LIBRARY: {
    href: '/library',
    eventName: 'library',
  },
  READER: {
    href: '/reader',
    eventName: 'library',
  },
  BIBLIOTECA: {
    href: '/biblioteca',
    eventName: 'biblioteca',
  },
  SPANISH_READER: {
    href: '/spanish-reader',
    eventName: 'biblioteca',
  },
  CAMINOS: {
    href: '/caminos',
    eventName: 'caminos-biblioteca',
  },
  CAMINOS_READER: {
    href: '/caminos-reader',
    eventName: 'caminos-biblioteca',
  },
  ELAR: {
    href: '/texas-elar',
    eventName: 'texas-elar',
  },
  ELAR_READER: {
    href: '/texas-elar-reader',
    eventName: 'texas-elar',
  },
  SLAR: {
    href: '/texas-slar',
    eventName: 'texas-slar',
  },
  SLAR_READER: {
    href: '/texas-slar-reader',
    eventName: 'texas-slar',
  },
  ELAR_V2: {
    href: '/texas-elar-2e',
    eventName: 'texas-elar-2e',
  },
  ELAR_V2_READER: {
    href: '/texas-elar-2e-reader',
    eventName: 'texas-elar-2e',
  },
  SLAR_V2: {
    href: '/texas-slar-2e',
    eventName: 'texas-slar-2e',
  },
  SLAR_V2_READER: {
    href: '/texas-slar-2e-reader',
    eventName: 'texas-slar-2e',
  },
}

export default HUB_PAGES
